<template>
  <v-dialog
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
    max-width="500">
    <v-card>
      <v-app-bar flat dark color="primary">
        <v-toolbar-title>Zeitnachweis löschen</v-toolbar-title>
      </v-app-bar>
      <v-card>
        <v-card-text>
          Sie möchten diesen Zeitnachweis wirklich löschen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="$emit('close')"
          >
            Abbrechen
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="deleteServiceTracking"
          >
            Löschen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
  import {serviceTrackingService} from '../../_services'
  export default {
    name: 'DeleteServiceTrackingConfirmDialog',
    props: {
      show: {
        type: Boolean,
        default: false
      },
      serviceTracking: {
        type: Object,
        default: function () {
          return {
            id: 0
          }
        }
      }
    },
    methods: {
      deleteServiceTracking () {
        serviceTrackingService.deleteServiceTracking(this.serviceTracking.id)
          .then(() => this.$store.dispatch('showNotification', {
            title: 'Zeiterfassung erfolgreich gelöscht.',
            type: 'primary'
          }))
          .finally(() => this.$emit('close'))
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ServiceTracking/DeleteServiceTrackingConfirmDialog.vue